import { createReduxSlice } from '@app/store/redux_slice'

type ErrorState = {
  code: number
  message?: string
  localizedMessage?: string
}

const errorSlice = createReduxSlice<ErrorState>('error')

export const errorSelector = errorSlice.selector

export const clearRouterErrorSlice = () => errorSlice.remove()

/** The first error of a route wins — a later throw must not replace what is already on screen. */
export const raiseRouterErrorSlice = (error: { errorCode: number; message?: string; localizedMessage?: string }) =>
  errorSlice.update(state => state ?? { code: error.errorCode, message: error.message, localizedMessage: error.localizedMessage })
